import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './home.scss';
import Firebase from '../../../services/firebase';
import CardHome from '../components/cardHome';
import NovaVenda from '../images/novaVenda.png';
import NovaRelatorio from '../images/novaRelatorio.png';
import Certificate from '../images/pp.jpg';
import FirebaseContext from '../../../context/firebase.context';
import PosicoesContext from '../../../context/posicoes.context';

function Coleta() {
  const { setIsScreenCertifield } = useContext(PosicoesContext);
  const { VerificaLogin, logado } = useContext(FirebaseContext);
  const history = useHistory();
  VerificaLogin('dashboard');
  const listItem = [
    {
      titulo: '(+) Cadastre uma venda',
      isModal: false,
      imagem: NovaVenda,
      valid: false,
      route: '/newsale',
      descricao: `Crie o registro de uma nova venda de insumo
      hormonal ao aplicador devidamente cadastrado na Secretária de Agricultura,
      Abastecimento e Desenvolvimento Rural do Rio Grande do Sul.`,
    },
    {
      titulo: 'Criador de relatórios',
      imagem: NovaRelatorio,
      isModal: false,
      valid: true,
      route: '/report',
      descricao: `Crie relatórios imprimíveis contendo gráficos
      e tabelas das suas vendas de insumos hormonais`,
    },
    {
      titulo: 'Certificados emitidos',
      imagem: Certificate,
      isModal: true,
      valid: false,
      route: '/list/certificates',
      descricao: 'Consulte os certificados de Rastreabilidade emitidos',
    },
  ];

  useEffect(() => {
    setIsScreenCertifield(false);
  }, []);

  useEffect(() => {
    Firebase.auth().onAuthStateChanged((user) => {
      const uid = user ? user.uid : 'deslogado';
      if (uid === 'deslogado') {
        history.push('/login');
      }
    });
  }, [logado]);

  return (
    <div id="home-coleta">
      <div className="content-coleta">
        <div className="titulo-coleta">
          <strong>
            Cadastrar nova venda
          </strong>
          <span>
            Selecione uma opção para começar
          </span>
        </div>
        <div className="cards-coleta">
          {
            listItem.map((item) => <CardHome item={item} />)
          }
        </div>
      </div>
    </div>
  );
}

export default Coleta;
